import ServiceError from '../ServiceError';

export function handleLoginError(error: unknown): ServiceError {
  let errorMessage = '';
  try {
    if ((error as { response: { status: number } }).response.status === 400)
      errorMessage = 'app.error.login.not-found';
  } catch (e) {
    throw new Error('app.error.unknow');
  }
  throw new Error(errorMessage === '' ? 'app.error.unknow' : errorMessage);
}

export function refreshTokenError(error: unknown): ServiceError {
  let errorMessage = '';
  try {
    if ((error as { response: { status: number } }).response.status === 400)
      errorMessage = 'app.error.refreshToken.not-found';
  } catch (e) {
    throw new Error('app.error.unknow');
  }
  throw new Error(errorMessage === '' ? 'app.error.unknow' : errorMessage);
}
